import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import '../vant-variables.less'

Vue.use(Vant)